import { ManagerBase } from '@core/ManagerBase';
import type { ILeaderboardManager } from '@core/interfaces';

/** Leaderboard — Phase 5+ implementasyon */
export class LeaderboardManager extends ManagerBase implements ILeaderboardManager {
  protected onInitialize(): void {
    // Phase 5
  }

  protected onShutdown(): void {
    // Phase 5
  }
}
